/* HerNext — NAD page: gallery, quantity + live total, variants, cross-sell toggles, ingredient selector, benefits accordion.
   Add to cart itself is handled by hernext.js (form[data-hn-atc]); unchecked cross-sell boxes keep an empty value so they are skipped. */
(function () {
  if (window.__hnNad) return;
  window.__hnNad = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmt(cents, host) {
    var cur = (host && host.getAttribute('data-currency')) || 'USD';
    var loc = (host && host.getAttribute('data-locale')) || 'en';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- Buy box ---------- */
  function initBuy(sec) {
    if (sec.__hnNad) return;
    sec.__hnNad = true;

    var form = sec.querySelector('form[data-hn-atc]');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    var max = parseInt(qty && qty.getAttribute('max'), 10) || 99;
    var price = parseInt(form.getAttribute('data-price'), 10) || 0;
    var totalEl = form.querySelector('[data-hn-total]');
    var addEl = form.querySelector('[data-hn-addons]');
    var one = form.getAttribute('data-addon-one') || '+ [N] add-on';
    var many = form.getAttribute('data-addon-many') || '+ [N] add-ons';

    // Subscriptions: per-variant selling-plan prices
    var plansData = null;
    var pj = form.querySelector('script[data-hn-plans]');
    if (pj) { try { plansData = JSON.parse(pj.textContent); } catch (x) { plansData = null; } }
    var planInput = form.querySelector('[data-hn-plan-input]');
    var idInput = form.querySelector('input[name="id"]');
    function currentPlan() {
      var r = form.querySelector('input[data-hn-plan]:checked');
      return r ? r.value : '';
    }
    function syncPlans() {
      if (!plansData || !idInput) return;
      var vd = plansData[idInput.value];
      if (!vd) return;
      var plan = currentPlan();
      var unit = plan && vd.plans[plan] != null ? vd.plans[plan] : vd.price;
      price = unit;
      if (planInput) { planInput.value = plan; planInput.disabled = !plan; }
      form.querySelectorAll('.hn-nad-plan').forEach(function (l) {
        var i = l.querySelector('input[data-hn-plan]');
        l.classList.toggle('is-on', !!(i && i.checked));
      });
      form.querySelectorAll('[data-hn-plan-price]').forEach(function (el) {
        var id = el.getAttribute('data-hn-plan-price');
        var now = id ? vd.plans[id] : vd.price;
        var n = el.querySelector('[data-now]');
        if (n && now != null) n.textContent = fmt(now, sec);
      });
      var pe = form.querySelector('[data-hn-price]');
      if (pe) pe.textContent = fmt(unit, sec);
      var ce = form.querySelector('[data-hn-compare]');
      if (ce) {
        var was = plan && vd.price > unit ? vd.price : (vd.compare > vd.price ? vd.compare : 0);
        ce.textContent = was ? fmt(was, sec) : '';
        ce.hidden = !was;
      }
    }

    function update() {
      syncPlans();
      var q = 1;
      if (qty) {
        q = Math.max(1, Math.min(max, parseInt(qty.value, 10) || 1));
        qty.value = q;
      }
      if (totalEl) totalEl.textContent = fmt(price * q, sec);
      var n = 0;
      form.querySelectorAll('input[name="hn_extra_id"][type="checkbox"]').forEach(function (c) {
        c.value = c.checked ? c.getAttribute('data-variant-id') : '';
        if (c.checked) n++;
      });
      if (addEl) addEl.textContent = n ? ' ' + (n === 1 ? one : many).replace('[N]', n) : '';
    }

    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hn-qty]');
      if (!b) return;
      e.preventDefault();
      if (qty) qty.value = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-hn-qty'), 10);
      update();
    });

    form.addEventListener('change', function (e) {
      var o = e.target;
      if (o.matches && o.matches('[data-hn-variant]')) {
        form.querySelector('input[name="id"]').value = o.value;
        price = parseInt(o.getAttribute('data-price'), 10) || 0;
        var pe = form.querySelector('[data-hn-price]');
        if (pe) pe.textContent = fmt(price, sec);
        var ce = form.querySelector('[data-hn-compare]');
        var cp = parseInt(o.getAttribute('data-compare'), 10) || 0;
        if (ce) { ce.textContent = cp > price ? fmt(cp, sec) : ''; ce.hidden = !(cp > price); }
        var avail = o.getAttribute('data-available') === 'true';
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = !avail;
        var lbl = form.querySelector('[data-hn-atc-label]');
        if (lbl) lbl.textContent = avail ? form.getAttribute('data-label') : form.getAttribute('data-soldout');
      }
      update();
    });

    // Shopify answers "already sold out" when a shipped item cannot be delivered to the shopper's
    // location (e.g. a country outside your shipping zones). Replace that misleading text.
    var errEl = form.querySelector('[data-hn-atc-error]');
    if (errEl && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (errEl.hidden || !/sold out/i.test(errEl.textContent)) return;
        var btn = form.querySelector('[type="submit"]');
        if (btn && btn.disabled && !btn.hasAttribute('aria-busy')) return;
        errEl.textContent = form.getAttribute('data-ship-error') || 'This item can’t be shipped to your location yet. We currently ship to the United States only.';
      }).observe(errEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }

    // Re-sync after a successful add (hernext.js fires this event)
    document.addEventListener('hernext:cart-added', function () { update(); });
    update();
  }

  /* ---------- Formula: segment bar + ingredient cards ---------- */
  function initFormula(sec) {
    if (sec.__hnNad) return;
    sec.__hnNad = true;
    sec.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hn-ing]');
      if (!t || !sec.contains(t)) return;
      var i = t.getAttribute('data-hn-ing');
      sec.querySelectorAll('[data-hn-ing-card]').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-hn-ing-card') === i); });
      sec.querySelectorAll('[data-hn-seg]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-hn-seg') === i); });
      sec.querySelectorAll('[data-hn-ing]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-hn-ing') === i ? 'true' : 'false'); });
      // Tapped the bar: bring the matching card into view (cards sit below the bar on phones)
      if (t.hasAttribute('data-hn-seg')) {
        var card = sec.querySelector('[data-hn-ing-card="' + i + '"]');
        if (card) {
          var r = card.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        }
      }
    });
  }

  /* ---------- Benefits accordion ---------- */
  function initAcc(wrap) {
    if (wrap.__hnNad) return;
    wrap.__hnNad = true;
    var exclusive = wrap.hasAttribute('data-hn-exclusive');
    wrap.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        // Fallback for browsers without <details name> grouping
        if (exclusive) wrap.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
        // Keep the opened box on screen when a panel above it closes
        requestAnimationFrame(function () {
          var r = d.getBoundingClientRect();
          if (r.top < 64) d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      });
    });
  }

  /* ---------- Subscriptions with the shared add-to-cart (hernext.js) ----------
     hernext.js posts {id, quantity} to /cart/add.js: add the chosen selling plan to that request. */
  var pendingPlan = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('[data-hn-nad-buy]')) return;
    var fd = new FormData(form), sp = fd.get('selling_plan');
    pendingPlan = sp ? { id: Number(fd.get('id')), plan: Number(sp), t: Date.now() } : null;
  }, true);
  if (window.fetch && !window.fetch.__hnNad) {
    var nativeFetch = window.fetch;
    var nadFetch = function (input, init) {
      if (pendingPlan) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
            var body = JSON.parse(init.body), it = body.items && body.items[0];
            if (it && Number(it.id) === pendingPlan.id && Date.now() - pendingPlan.t < 15000) {
              it.selling_plan = pendingPlan.plan;
              init = Object.assign({}, init, { body: JSON.stringify(body) });
            }
            pendingPlan = null;
          }
        } catch (x) { pendingPlan = null; }
      }
      return nativeFetch.apply(window, [input, init]);
    };
    nadFetch.__hnNad = true;
    nadFetch.__hns = window.fetch.__hns;
    window.fetch = nadFetch;
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-hn-nad-buy]').forEach(initBuy);
    root.querySelectorAll('[data-hn-formula]').forEach(initFormula);
    root.querySelectorAll('[data-hn-acc]').forEach(initAcc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
